__turbopack_context__.v({
  "bar": "StickyPurchaseBar-module-scss-module__MxoPBq__bar",
  "content": "StickyPurchaseBar-module-scss-module__MxoPBq__content",
  "cta": "StickyPurchaseBar-module-scss-module__MxoPBq__cta",
  "name": "StickyPurchaseBar-module-scss-module__MxoPBq__name",
  "price": "StickyPurchaseBar-module-scss-module__MxoPBq__price",
  "purchase": "StickyPurchaseBar-module-scss-module__MxoPBq__purchase",
  "recap": "StickyPurchaseBar-module-scss-module__MxoPBq__recap",
  "slideUp": "StickyPurchaseBar-module-scss-module__MxoPBq__slideUp",
  "spacer": "StickyPurchaseBar-module-scss-module__MxoPBq__spacer",
  "thumbnail": "StickyPurchaseBar-module-scss-module__MxoPBq__thumbnail",
});
